import React from 'react';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import {defaultVariabls} from "../../../../config";
import FormControl from "@material-ui/core/FormControl/FormControl";
import LoadingButton from "../../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import SubTitle from "../../../components/elements/SubTitle";
import {Translate} from "../../../../config/Translate";
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
class UserDashboardConfirmation extends React.Component{
    open = this.props.new;
    state= {
        dialogOpen: (!this.props.user.shops.length),
        checked:false,
        no_confirmation:false,
        SubmitLoading:false,
    };
    classes = this.props.classes;
    handleSubmit(){
        this.setState({
            SubmitLoading:true,
            dialogOpen:false,
        })
        if(this.state.no_confirmation){
            this.props.handleNotAccepeted()
        }

    }
    render(){
        let{checked,SubmitLoading,no_confirmation} = this.state;
        console.log(this.props.user)
        return (
            <>
                <Dialog
                    open={this.state.dialogOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'xs'}
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title" className={this.classes.alertText}>
                        <SubTitle >{Translate.welcomeToRequestToSupplier}</SubTitle>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography className={this.classes.textFloat}>{Translate.welcomeToRequestToSupplierDesc}</Typography>
                            </Grid>
                            <Grid item xs={12} className={this.classes.textFloat}>
                                <FormControl required  component="fieldset">
                                    <FormControlLabel
                                        control={<Checkbox checked={checked} onChange={() => this.setState({checked:!checked,no_confirmation:false})} />}
                                        label={
                                            <Typography align="center" className="privacy_policy text-center">
                                                {Translate.withRequestingShop}
                                                {" "}
                                                <a target="_blank" href={`${defaultVariabls.website}/supplier-terms`} >
                                                    {Translate.shopRules}
                                                </a>
                                                {" "}
                                                {Translate.privacyPolicyConfirmationShop}
                                            </Typography>
                                        }
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={no_confirmation} disabled={checked} onChange={() => this.setState({no_confirmation:!no_confirmation})} />}
                                        label={
                                            <Typography align="center" style={{fontSize:11,color:"#ed1d1d"}} className="privacy_policy text-center">
                                                {Translate.privacyPolicyNotConfirmationShop}
                                            </Typography>
                                        }
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} >
                                <FormControl required  component="fieldset">

                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                <Button
                                    size="small"
                                    onClick={() => this.props.history.goBack()}
                                    startIcon={<ChevronRightRoundedIcon/>}
                                >
                                    {Translate.back}
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    disabled={!checked && !no_confirmation}
                                    onClick={this.handleSubmit.bind(this)}
                                    loading={SubmitLoading}
                                >
                                    {Translate.submit}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(UserDashboardConfirmation))));